import { useDeveloperRoutes } from '../developers/developers.routes';

export const useCustomerDeveloperRoutes = () =>
  useDeveloperRoutes('/customer/developers');
